import {FunctionComponent, InputHTMLAttributes} from 'react';
import clsx from 'clsx';
import {twMerge} from 'tailwind-merge';
import CheckIcon from '@/assets/images/icon-check.svg?react';
import {useFormControlContext} from '@/components/form/form-control/form-control';

type ElementProps = InputHTMLAttributes<HTMLInputElement> & {
  'label'?: string;
  'data-testvalue'?: string;
};

const Checkbox: FunctionComponent<ElementProps> = ({label, 'data-testvalue': dataTestValue, ...props}) => {
  const {isDisabled} = useFormControlContext();

  const mergedLabelClasses = clsx(
    'flex cursor-pointer items-center gap-2',
    isDisabled && 'cursor-not-allowed opacity-50',
  );

  return (
    <label aria-disabled={isDisabled} className={twMerge(mergedLabelClasses)} data-testvalue={dataTestValue}>
      <div className="relative leading-none">
        <input
          className="peer relative size-5 cursor-pointer appearance-none rounded-md border border-violet transition-all checked:border-violet checked:bg-violet"
          type="checkbox"
          disabled={isDisabled}
          {...props}
        />

        <CheckIcon
          role="presentation"
          className="absolute left-3 top-3 z-20 size-4 translate-x-[-10px] translate-y-[-10px] fill-white opacity-0 transition-opacity peer-checked:opacity-100"
        />
      </div>

      <div className="leading-none text-charcoal">
        {label}

        {/* eslint-disable-next-line i18next/no-literal-string */}
        {props.required && <sup className="text-red">*</sup>}
      </div>
    </label>
  );
};

export default Checkbox;
